import { ColumnDef } from '@tanstack/react-table';
import { get } from 'lodash';

import { Approval } from '@/app/org-cfv/src/typings/ActivityDataDetailsTypings';
import { EmissionsType } from '@/app/org-cfv/src/typings/CreateActivityDataTypings';
import { NextTFunction } from '@/i18n/client';

// This file contains the columns for cat3.2

export const getProductLineNameHeader = (t: NextTFunction): ColumnDef<Approval & EmissionsType> => {
  return {
    header: t('fd-product-line.productLineName'),
    accessorKey: 'metadata.productLineName',
  };
};

export const getProductSeriesNameHeader = (t: NextTFunction): ColumnDef<Approval & EmissionsType> => {
  return {
    header: t('fd-product-line.productSeriesName'),
    accessorKey: 'metadata.productSeriesName',
  };
};

export const getProductMaterialsPartNoHeader = (
  t: NextTFunction,
  isBulkPreview: boolean = false,
): ColumnDef<Approval & EmissionsType> => {
  return {
    header: t('fd-product-line.productMaterialCode'),
    accessorKey: isBulkPreview ? 'metadata.productMaterialsPartNo' : 'activityData.metadata.productMaterialsPartNo',
  };
};

export const getProductMaterialsCommentHeader = (t: NextTFunction): ColumnDef<Approval & EmissionsType> => {
  return {
    header: t('fd-raw-material.partDescription'),
    accessorKey: 'metadata.productMaterialsComment',
  };
};

export const getCustomerCodeHeader = (t: NextTFunction): ColumnDef<Approval & EmissionsType> => {
  return {
    header: t('fd-distribution-transportation.customerCode'),
    accessorKey: 'metadata.customerCode',
  };
};

export const getReceivingLocationCodeHeader = (t: NextTFunction): ColumnDef<Approval & EmissionsType> => {
  return {
    header: t('fd-distribution-transportation.receivingLocationCode'),
    accessorKey: 'metadata.receivingLocationCode',
  };
};

export const getCustomerCodeAndNameHeader = (
  t: NextTFunction,
  isBulkPreview: boolean = false,
): ColumnDef<Approval & EmissionsType> => {
  return {
    header: t('fd-distribution-transportation.customerCodeAndName'),
    accessorKey: isBulkPreview ? 'metadata.customerCode' : 'activityData.metadata.customerCode',
    cell: ({ row: { original }, getValue }) => {
      const keyPrefix = isBulkPreview ? 'metadata' : 'activityData.metadata';
      return `${getValue()} ${get(original, `${keyPrefix}.customerName`, '')}`;
    },
  };
};

export const getReceivingLocationCodeAndNameHeader = (
  t: NextTFunction,
  isBulkPreview: boolean = false,
): ColumnDef<Approval & EmissionsType> => {
  return {
    header: t('fd-distribution-transportation.receivingLocationCodeAndName'),
    accessorKey: isBulkPreview ? 'metadata.receivingLocationCode' : 'activityData.metadata.receivingLocationCode',
    cell: ({ row: { original }, getValue }) => {
      const keyPrefix = isBulkPreview ? 'metadata' : 'activityData.metadata';
      return `${getValue()} ${get(original, `${keyPrefix}.receivingLocationName`, '')}`;
    },
  };
};
